import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';
import { namespace } from 'vuex-class';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import BriefingService from '@/service/briefing.service';
import { documentCard } from '@/shared/model/document-card.model';
import { checkIfIsBase64Image, getHostName, onlyInLeft, timeDifference } from '@/util/ds-util';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';

const briefingStore = namespace('briefingStore');

@Component({
  components: {
    'ref-item': RefCardItem,
    'go-loading': ListLoading,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class RefMyScrapComponent extends Vue {
  @briefingStore.Getter
  getAddingReferenceDocuments!: Array<any>;

  @briefingStore.Mutation
  public setAddingReferenceDocuments!: (payload: any) => void;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  scrollSettings = {
    wheelPropagation: false,
  };
  loadingGetMyResources = false;
  myScrapResourceList = [];
  selectedItems = [];
  SCRAPE_EXCLUDE_TYPES = ['CHAT_HISTORY'];

  mounted() {
    this.getMyResources();
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  @Watch('getAddingReferenceDocuments')
  onGetAddingReferenceDocumentsChange() {
    if (this.getAddingReferenceDocuments === null || this.getAddingReferenceDocuments.length === 0) {
      this.selectedItems = [];
    }
  }

  async getMyResources() {
    this.loadingGetMyResources = true;
    const userKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    try {
      const scrapBpResponse = await this.briefingService().callAPIGetDefaultBpIdScrapAgent(userKey, null, 0, 1, true);
      if (scrapBpResponse.data?.body?.success) {
        const defaultScrap = scrapBpResponse.data?.body?.body?.briefingPageList;
        if (defaultScrap && defaultScrap.length) {
          const defaultScrapId = defaultScrap[0].bpId;
          const scrapResourcesResp = await this.briefingService().getAllMyBriefingData(
            defaultScrapId,
            ['SCRAPE'],
            null,
            null,
            // filterPayload.dateText,
            null,
            null,
            ['en', 'ko'],
            true,
            true,
            0,
            10000,
            new Date().getTime().toString(),
            null,
            [0, 1, 2]
          );
          if (scrapResourcesResp.data?.statusCodeValue == 200) {
            const scrapResources = scrapResourcesResp.data?.body?.body?.discoveryReportDTO?.listBriefingData;
            this.myScrapResourceList = this.modifyData(
              scrapResources.filter((el: any) =>
                el.parentDocDetail.media_type.every((type: string) => !this.SCRAPE_EXCLUDE_TYPES.includes(type))
              )
            );
            this.myScrapResourceList = await this.badArrToGoodArr(this.myScrapResourceList, false);
          }
        }
      }
    } catch (e) {
      // todo
    } finally {
      this.loadingGetMyResources = false;
    }
  }

  modifyData(dataInput: any[]): any[] {
    const tempList = [];

    dataInput.forEach(resource => {
      if (resource !== null && resource.parentDocDetail !== null) {
        const tempItemData = {
          title: resource.parentDocDetail.title ? resource.parentDocDetail.title : '',
          description: resource.parentDocDetail.source_summary ? resource.parentDocDetail.source_summary : '',
          link: resource.parentDocDetail.source_uri ? resource.parentDocDetail.source_uri : '',
          searchType: resource.parentDocDetail.search_type ? resource.parentDocDetail.search_type[0] : '',
          mediaType: resource.parentDocDetail.media_type ? resource.parentDocDetail.media_type : [''],
          author: resource.parentDocDetail.author || '',
          writer: resource.parentDocDetail.writer || [''],
          keyword: resource.parentDocDetail._ml_keyword ? resource.parentDocDetail._ml_keyword : '',
          lang: resource.parentDocDetail.service_language ? (resource.parentDocDetail.service_language === 'ENGLISH' ? 'en' : 'ko') : 'en',
          channel: resource.parentDocDetail.channel ? resource.parentDocDetail.channel : '',
          docId: resource.parentDocDetail.parent_doc_id
            ? resource.parentDocDetail.parent_doc_id[0]
            : resource.resourceId
            ? resource.resourceId
            : '',
          parentDocId: resource.parentDocDetail.parent_doc_id
            ? resource.parentDocDetail.parent_doc_id[0]
            : resource.resourceId
            ? resource.resourceId
            : '',
          create_date: resource.parentDocDetail.created_at
            ? resource.parentDocDetail.created_at
            : resource.createdDate
            ? resource.createdDate
            : '',
          image_uri: resource.parentDocDetail.image_uri ? resource.parentDocDetail.image_uri : [''],
          image_uri_thumbnail: resource.image_uri_thumbnail
            ? resource.image_uri_thumbnail
            : resource.parentDocDetail.image_uri_thumbnail
            ? resource.parentDocDetail.image_uri_thumbnail
            : '',
          userKey: resource.parentDocDetail.user_key ? resource.parentDocDetail.user_key : '',
          favicon: resource.parentDocDetail.favicon ? resource.parentDocDetail.favicon : '',
          path: resource.parentDocDetail.source_uri
            ? resource.parentDocDetail.source_uri
            : resource.parentDocDetail.path
            ? resource.parentDocDetail.path
            : '',
          docType: resource.parentDocDetail.doc_type ? resource.parentDocDetail.doc_type : 1,
          published_at: resource.parentDocDetail.published_at ? resource.parentDocDetail.published_at : '',
          service_html: resource.parentDocDetail.service_html ? resource.parentDocDetail.service_html : '',
          owner_user_key: resource?.owner_user_key
            ? resource?.owner_user_key
            : resource?.originParentDocDetail?.owner_user_key
            ? resource?.originParentDocDetail?.owner_user_key
            : null,
        };

        tempList.push(tempItemData);
      }
    });

    return tempList;
  }

  removeCardReq(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) this.selectedItems.splice(index, 1);
  }

  removeReferenceDocument(item) {
    if (this.getAddingReferenceDocuments !== null && this.getAddingReferenceDocuments.length > 0) {
      const index = this.getAddingReferenceDocuments.indexOf(item);

      if (index !== -1) {
        this.getAddingReferenceDocuments.splice(index, 1);
        this.setAddingReferenceDocuments(this.getAddingReferenceDocuments);
      }
    }
  }

  removeCardInList(item) {
    const index = this.myScrapResourceList.indexOf(item);
    if (index !== -1) this.myScrapResourceList.splice(index, 1);
    this.removeCardReq(item);
    this.removeReferenceDocument(item);
  }

  selectAddingReferenceDocument(item) {
    let index = -1;

    if (this.selectedItems !== null && this.selectedItems.length > 0) {
      index = this.selectedItems.indexOf(item);
    }

    if (index !== -1) {
      this.selectedItems.splice(index, 1);
      this.removeReferenceDocument(item);
    } else {
      this.selectedItems.push(item);
      this.setAddingReferenceDocuments([...(this.getAddingReferenceDocuments ? this.getAddingReferenceDocuments : []), item]);
    }
  }

  // async test(item) {
  //   if (item.favicon) {
  //     if (item.favicon.startsWith('data:image/png;base64')) return;
  //     if (item.favicon.includes('/favicon.ico')) item.favicon = await toDataURL(item.favicon);
  //   } else item.favicon = null;
  // }

  async badArrToGoodArr(arr, typeDownload?) {
    const results: documentCard[] = await Promise.all(
      arr
        .filter(item => item.title || item.description || [item.imgBase64 ? item.imgBase64 : item.img ? item.img : ''])
        .map(async item => {
          // await this.test(item);
          const objectTmp = new documentCard();
          if (item.author) objectTmp.author = item.author;
          else objectTmp.author = getHostName(item.link);
          objectTmp.title = item.title ? item.title : '';
          objectTmp.content = item.content ? item.content : '';
          objectTmp.keyword = item.keyword ? item.keyword : '';
          objectTmp.type = typeDownload ? 'DOWNLOAD' : 'URL';
          objectTmp.searchType = item.searchType ? item.searchType : 'WEB';
          objectTmp.addedAt = item.org_date ? item.org_date : item.datetime ? timeDifference(new Date(), new Date(item.datetime)) : '';
          objectTmp.url = item.link ? item.link : item.url ? item.url : '';
          objectTmp.favicon = item.favicon ? (!checkIfIsBase64Image(item.favicon) ? item.favicon : '') : '';
          objectTmp.docId = item.docId ? item.docId : item.docId;
          objectTmp.noConvertTime = true;
          objectTmp.tags = item.tags ? item.tags : [''];
          objectTmp.typeRemove = 'My Resource';
          objectTmp.mediaType = item.mediaType ? item.mediaType : ['WEB'];
          objectTmp.description = item.description ? item.description : '';
          objectTmp.image_uri = item.image_uri ? item.image_uri : [''];
          objectTmp.image_uri_thumbnail = item.image_uri_thumbnail
            ? !checkIfIsBase64Image(item.image_uri_thumbnail)
              ? item.image_uri_thumbnail
              : ''
            : item.image
            ? !checkIfIsBase64Image(item.image)
              ? item.image
              : ''
            : '';
          objectTmp.path = item.path ? item.path : '';
          objectTmp.create_date = item.create_date || '';
          objectTmp.channel = item.channel
            ? item.channel
            : item.link
            ? getHostName(item.link)
            : item.url
            ? getHostName(item.url)
            : item.path
            ? getHostName(item.path)
            : item.author
            ? getHostName(item.author)
            : '';
          objectTmp.docType = 1;
          objectTmp.published_at = item.published_at ? item.published_at : '';
          objectTmp.service_html = item.service_html ? item.service_html : '';
          objectTmp.writer = item.writer ? item.writer : item.author ? [item.author] : [''];
          objectTmp.owner_user_key = item.owner_user_key ? item.owner_user_key : null;

          return objectTmp;
        })
    );

    //remove duplicate
    return onlyInLeft(results, this.myScrapResourceList, ['docId', 'url']);
  }

  openNewTab(url: string) {
    window.open(url, '_blank');
  }
}
